import type { StatusTone } from '@buildmate/tokens';
import { cn } from './cn.ts';

const TONE_CLASS: Record<StatusTone, string> = {
  neutral: 'bg-slate-100 text-slate-700 ring-slate-200',
  info: 'bg-blue-50 text-blue-700 ring-blue-200',
  pending: 'bg-amber-50 text-amber-700 ring-amber-200',
  success: 'bg-green-50 text-green-700 ring-green-200',
  danger: 'bg-red-50 text-red-700 ring-red-200',
};

export interface BadgeProps {
  readonly tone?: StatusTone;
  readonly children: React.ReactNode;
  readonly className?: string;
}

/**
 * A status pill.
 *
 * The label always carries the meaning, so colour is never the only signal —
 * required for accessibility and for anyone printing a report in greyscale.
 */
export function Badge({ tone = 'neutral', children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium uppercase tracking-wide ring-1 ring-inset',
        TONE_CLASS[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
